<script setup lang="ts">
import { NConfigProvider, NMessageProvider, NSpin } from 'naive-ui'
import { darkTheme } from 'naive-ui'
import { useSessionStore } from './stores/session'
import { storeToRefs } from 'pinia'
import { useRefreshOnVisible } from './composables/useRefreshOnVisible'
import { useDisplayDensity } from './composables/useDisplayDensity'
import SignInForm from './views/SignInForm.vue'
import { naiveThemeOverrides } from './theme/tokens'

const session = useSessionStore()
const { checked, currentUser } = storeToRefs(session)

// Re-sync the current user when the tab regains visibility so state
// another device may have mutated (notably last_seen_log_at)
// doesn't stay stale. No-op while signed out.
useRefreshOnVisible(() => {
  if (currentUser.value) void session.fetchCurrentUser()
})

// Mirror the signed-in user's density preference onto <html> so every
// view that opts into density-conditional CSS picks it up automatically.
useDisplayDensity()

// Naive UI keeps its dark theme as the base and takes the "Graphite &
// Signal" palette from `theme/tokens.ts` — the same values the Tailwind
// `@theme` block uses, pinned together by `theme/tokens.spec.ts`.
</script>

<template>
  <NConfigProvider :theme="darkTheme" :theme-overrides="naiveThemeOverrides">
    <NMessageProvider>
      <div v-if="!checked" class="flex items-center justify-center h-screen">
        <NSpin size="large" />
      </div>
      <SignInForm v-else-if="!currentUser" />
      <RouterView v-else />
    </NMessageProvider>
  </NConfigProvider>
</template>
